// import { useMutation } from "@tanstack/react-query";
import React, {
  createContext,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { apiOperador } from "../services/api";
import { useCookies } from "react-cookie";
import jwtDecode from "jwt-decode";
import axios from "axios";

interface OperadorContextProviderProps {
  children: ReactNode;
}

interface OperadorContextProps {
  page: number;
  tab: string;
  loading: boolean;
  setTab: (value: string) => void;
  setPage: (page: number | SetStateAction<number>) => void;
  loadData: (filters: FilterProps) => Promise<Data | undefined>;
  loadVendedores: () => Promise<void>;
  loadAssessorias: () => Promise<void>;
  clearData(): void
  createCampanhaWhats(campanha: {
    fila: { cpf_cnpj: string, telefone: string }[];
    id_loja: number;
    cod_namespace: string;
    id_tipo_template: number;
    custo: number;
    cod_numero: string;
    cod_template: string;
    id_fila: string
  }): Promise<void>
  findCampanhaWhats(cpfCnpj: string): Promise<any>
  sendCampanhaAPI(campanha: []): Promise<any>
  getRelatorioCampanha(id_campanha: number): Promise<any>
  loadCampanhas(): Promise<void>
  filtros: FilterProps;
  setFiltros: (filtros: FilterProps) => void;
  data: Data | null;
  vendedores: VendedorProps[];
  assessorias: AssessoriasProps[];
  classificacoes: string[]
  loadingCampanha: boolean
  campanhas: Campanha[]
}

export interface VendedorProps {
  nome_vendedor: string;
}

export interface AssessoriasProps {
  assessoria: string;
}

export interface ClassificacaoProps {
  classificacao: string;
}

export interface ProducaoData {
  loja: number;
  datamov: string;
  acionamentos: number;
  agendamentos: number;
  valor_agendado: string;
}

export interface Data {
  contratos: number;
  a_cobrar: number;
  valor_vencido: number;
  valor_a_vencer: number;
  data: DataItem[];
  producao?: ProducaoData
  orcamento_diario: {
    utility_disponivel: number,
    utility_orcamento: number
  }
  orcamento_mensal: {
    utility_disponivel: number,
    utility_orcamento: number
  }
}

export interface DataItem {
  id_lista_loja: number;
  loja: number;
  cpf_cnpj: string;
  nome_cliente: string;
  nome_vendedor: string;
  atraso: number;
  valor_vencido: number;
  valor_a_vencer: number;
  assessoria: string;
  data_ultimo_acionamento: string;
  data_ultimo_whatsapp: string;
  data_agendamento: string;
  id_processo: string;
  processo: string;
  fone1?: string;
  fone2?: string;
  fone3?: string;
  fone4?: string;
  fone5?: string;
  fone6?: string;
  fone7?: string;
  fone8?: string;
  email?: string;
  data_lista?: string;
  classificacao: string;
  uf?: string;
  cidade?: string;
  bairro?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
}

interface FilterProps {
  page: number;
  loja?: number;
  assessoria?: string;
  de?: number;
  ate?: number;
  valor_inicial?: number;
  valor_final?: number;
  vendedor?: string;
  data?: string;
  agendamentos?: string;
  acionamentos?: string;
  processos?: string;
  shouldNotRefresh?: boolean;
  data_producao?: string
  classificacao?: string
}

export interface Campanha {
  id_campanha: number
  data_hora_criacao: string
  cod_empresa_gazin: number
  cod_regional: number
  template: string
  quant_envio: number
  custo: string
  status: boolean
}

const OperadorContext = createContext<OperadorContextProps>(
  {} as OperadorContextProps
);

export const OperadorProvider = ({
  children,
}: OperadorContextProviderProps) => {
  const [tab, setTab] = useState("fila-cobranca");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingCampanha, setLoadingCampanha] = useState(false);
  const [vendedores, setVendedores] = useState<VendedorProps[]>([]);
  const [assessorias, setAssessorias] = useState<AssessoriasProps[]>([]);
  const [data, setData] = useState<Data | null>(null);
  const [cookies] = useCookies(["token"]);
  const [filtros, setFiltros] = useState<FilterProps>({
    page
  });
  const [classificacoes, setClassificacoes] = useState<string[]>([])
  const [campanhas, setCampanhas] = useState<Campanha[]>([] as Campanha[])

  async function loadData(params: FilterProps | null) {
    if (!params?.shouldNotRefresh) setLoading(true);
    try {
      const { token } = cookies;
      const decoded = jwtDecode(token) as any;
      // console.log(decoded)
      const { data } = await apiOperador.get<{
        data: Data;
      }>("https://malta-ws.gazin.com.br:3000/operador-cadastro/", {
        params: {
          cpf_cnpj: decoded.cpf_cnpj,
          loja: decoded.id_loja,
          ...params,
        },
      });
      const dataRequest = data.data;
      loadClassificacao(dataRequest!)
      if (params?.classificacao === 'all' || params?.classificacao === undefined) {
        setData(dataRequest);
        return dataRequest;
      } else {
        const newData = dataRequest.data.filter(item => item.classificacao === params.classificacao)
        setData({ ...dataRequest, data: newData });
        return { ...dataRequest, data: newData };
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }



  async function loadVendedores() {
    const { token } = cookies;
    const decoded = jwtDecode(token) as any;
    const { data } = await apiOperador.get("/vendedor", {
      params: {
        loja: decoded.id_loja,
      },
    });
    const vendedores = data.vendedores.filter(
      (value: { nome_vendedor: string }) => value.nome_vendedor !== null
    );
    setVendedores(
      vendedores.sort(
        (
          a: {
            nome_vendedor: string;
          },
          b: {
            nome_vendedor: string;
          }
        ) =>
          a.nome_vendedor
            .toLowerCase()
            .localeCompare(b.nome_vendedor.toLowerCase())
      )
    );
  }

  async function loadAssessorias() {
    const { token } = cookies;
    const decoded = jwtDecode(token) as any;
    const { data } = await apiOperador.get("/assessorias", {
      params: {
        loja: decoded.id_loja,
      },
    });
    const assessorias = data.assessorias.filter(
      (value: { assessoria: string }) => value.assessoria !== null
    );
    setAssessorias(
      assessorias.sort(
        (
          a: {
            assessoria: string;
          },
          b: {
            assessoria: string;
          }
        ) =>
          a.assessoria.toLowerCase().localeCompare(b.assessoria.toLowerCase())
      )
    );
  }


  async function loadClassificacao(data: Data) {
    if (data && data.data.length === 0) return
    const classi = data.data.map(item => item.classificacao)
    const classificacao = Array.from(new Set(classi)).sort()
    setClassificacoes(classificacao)
  }

  async function createCampanhaWhats(campanha: { fila: { cpf_cnpj: string, telefone: string }[], id_loja: number, cod_namespace: string, id_tipo_template: number, custo: number, cod_numero: string, cod_template: string, id_fila: string }) {
    try {
      setLoadingCampanha(true)
      const { data } = await apiOperador.post("https://malta-ws.gazin.com.br:3000/orcamento-whatsapp/campanha", {
        cod_empresa_gazin: campanha.id_loja,
        namespace: campanha.cod_namespace,
        id_tipo_template: campanha.id_tipo_template,
        custo: campanha.custo, // 0.7
        cod_numero: campanha.cod_numero,
        cod_template: campanha.cod_template,
        fila: campanha.fila,
        id_fila: campanha.id_fila,
        cod_regional: campanha.id_loja,
      });
      return data.data
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCampanha(false);

    }
  }

  async function findCampanhaWhats(cpfCnpj: string) {
    setLoadingCampanha(true)
    try {

      const { data } = await apiOperador.get('https://malta-ws.gazin.com.br:3000/orcamento-whatsapp/campanha/fila', {
        params: {
          cpfCnpj
        }
      })
      return data.data
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoadingCampanha(false);

    }
  }


  async function sendCampanhaAPI(campanha: []) {
    setLoadingCampanha(true)
    try {
      // console.log({
      //   sendWhastAppMessageRequest: campanha
      // })
      const { data } = await axios.post('https://hboqegnnqi.execute-api.us-east-2.amazonaws.com/messages/template', {
        sendWhastAppMessageRequest: campanha
      })
      return data
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingCampanha(false);

    }
  }

  async function loadCampanhas() {
    const { data } = await apiOperador.get('https://malta-ws.gazin.com.br:3000/orcamento-whatsapp/campanha/', {
    })
    setCampanhas(data.data)
    return
  }

  async function getRelatorioCampanha(id_campanha: number) {
    const { data } = await apiOperador.get('https://malta-ws.gazin.com.br:3000/orcamento-whatsapp/campanha/relatorio', {
      params: {
        id_campanha
      }
    })
    return data.data
  }

  useEffect(() => {
    loadData(filtros);
    loadVendedores();
    loadAssessorias();
    loadCampanhas()
  }, []);

  function clearData() {
    setVendedores([])
    setAssessorias([])
    setFiltros({
      page: 0
    })
    setPage(0)
    setData(null)
    setClassificacoes([])
    setCampanhas([])
  }

  return (
    <OperadorContext.Provider
      value={{
        page,
        tab,
        loading,
        setTab,
        setPage,
        filtros,
        setFiltros,
        vendedores,
        assessorias,
        data,
        classificacoes,
        loadData,
        loadVendedores,
        loadAssessorias,
        clearData,
        createCampanhaWhats,
        loadingCampanha,
        findCampanhaWhats,
        sendCampanhaAPI,
        getRelatorioCampanha,
        campanhas,
        loadCampanhas
      }}
    >
      {children}
    </OperadorContext.Provider>
  );
};

export const useOperador = () => useContext(OperadorContext);
